import React, { useRef, useState, useCallback } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './SelectInputStyles.scss';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import CheckBoxInputWithLabel from '../CheckBoxInput/CheckBoxInputWithLabel';

export default function CustomSelectInput(props) {
  const {
    inputProps = null,
    className = '',
    options = [],
    fieldState = {
      error: '',
      touched: false,
    },
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
    renderOption = null,
    addPlaceholder = false,
    useDefaultNull = false,
    placeholder = '',
    multiple = false,
    customToggleContent = null,
    disabled = false,
    inputClassName = '',
    portalClassName = '',
    variant = '',
  } = props;
  const {
    error,
    isTouched: touched,
  } = fieldState;
  const { formatMessage } = useIntl();
  const [toggleFunction, setToggleFunction] = useState(() => () => {});
  const anchorElement = useRef(null);
  const isError = Boolean(error);
  const defaultRenderOption = item => (!item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || '');
  let renderOptionFunction = defaultRenderOption;
  if (renderOption && typeof renderOption === 'function') {
    renderOptionFunction = renderOption;
  }
  const defaultValue = multiple ? [] : '';
  let ipv = inputProps && (typeof inputProps.value !== 'undefined') ? inputProps.value : defaultValue;
  if (multiple && !Array.isArray(ipv)) {
    // Это добавлено на случай когда inputProps.value = "" возможно нужно подумать
    ipv = defaultValue;
  }
  const value = multiple ? Array.isArray(ipv) ? ipv : [ipv] : ipv;
  const name = inputProps && (typeof inputProps.name !== 'undefined') ? inputProps.name : '';
  const isArrayValue = Array.isArray(value);
  const onChange = item => {
    if (!inputProps?.onChange) {
      return;
    }
    let changeValue = item.value;
    if (multiple) {
      const newValue = Array.isArray(value) ? [...value] : [value];
      const index = value.indexOf(item.value);
      if (index > -1) {
        newValue.splice(index, 1);
      } else {
        newValue.push(item.value);
      }
      changeValue = newValue;
    } else if (changeValue === value) {
      changeValue = useDefaultNull ? null : '';
    }
    inputProps.onChange({ target: { value: changeValue, name: inputProps.name } });
  };

  const onReset = event => {
    const v = multiple ? [] : useDefaultNull ? null : '';
    inputProps.onChange({ target: { value: v, name: inputProps.name } });
    event.preventDefault();
    event.stopPropagation();
  };

  let inputValue = '';
  if (!multiple) {
    const inputOption = options.find(i => i.value === value);
    inputValue = inputOption ? defaultRenderOption(inputOption) : '';
  } else {
    const selectedItems = options.filter(item => isArrayValue && value.includes(item.value)).map(defaultRenderOption);
    inputValue = selectedItems.join(', ');
  }
  const isSelectedPlaceholder = value => {
    if ((Array.isArray(value) && !value.length) || value === null) {
      return true;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      return !String(value);
    }
    return false;
  };

  const isAll = multiple && Array.isArray(value) ? options.every(o => value.includes(o.value)) : false;
  const isSome = multiple && Array.isArray(value) ? options.some(o => value.includes(o.value)) && !isAll : false;
  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        usePortal
        disabled={disabled}
        setToggleFunction={a => setToggleFunction(() => a)}
      >
        <Dropdown.Toggle className="select-toggle">
          {!customToggleContent || typeof customToggleContent !== 'function'
            ? (
              <TextInput
                {...props}
                readOnly
                inputAfter={(
                  <div id={controlId} className="select-arrow-wrapper">
                    {inputValue ? <Icons customIcon onClick={onReset} width={18} height={18} icon="close" /> : null}
                    <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                  </div>
              )}
                className={classNames('custom-select', { 'is-invalid': isError && touched }, inputClassName)}
                fieldState={fieldState}
                containerRef={anchorElement}
                inputProps={{
                  name,
                  onChange: () => {},
                  value: inputValue,
                  // onBlur: () => typeof toggleFunction === 'function' && setTimeout(() => toggleFunction(false), 100),
                  // onFocus: () => typeof toggleFunction === 'function' && toggleFunction(true),
                }}
                variant={variant}
              />
            )
            : customToggleContent(props, value, options, anchorElement)}
        </Dropdown.Toggle>
        <Dropdown.Menu useResizeContent={false} disableClickToggle={multiple} rightPadding={32} className="select-options-wrapper" anchorElement={anchorElement} classNamePortal={classNames('portal-select-options', portalClassName)}>
          <div className="select-options-list">
            {multiple ? (
              <div
                className="select-option"
                onClick={() => {
                  if (isAll) {
                    inputProps.onChange({ target: { value: [], name: inputProps.name } });
                  } else {
                    inputProps.onChange({ target: { value: options.map(o => o.value), name: inputProps.name } });
                  }
                }}
              >
                <CheckBoxInputWithLabel
                  inputClassName={classNames({ 'some-child': isSome }, { 'every-child': isAll })}
                  inputProps={{
                    value: isAll,
                    onChange: e => {
                    },
                  }}
                  label={formatMessage({ id: 'select.all' })}
                />
              </div>
            ) : null}

            {options.map((item, key) => {
              let isSelected = item.value === value;
              if (multiple) {
                isSelected = isArrayValue && !!value.includes(item.value);
              }
              return (
                <div
                  key={key}
                  className={classNames('select-option', { selected: isSelected })}
                  onClick={() => {
                    onChange(item);
                  }}
                >
                  <CheckBoxInputWithLabel
                    inputProps={{ value: isSelected, onChange: () => {} }}
                    label={renderOptionFunction(item)}
                  />
                </div>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
